// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3d38bddc].v-chip.tag {\n  border-radius: 18px;\n  height: 27px;\n  font-size: 12px;\n}\n[data-v-3d38bddc].v-chip.tag.small {\n  height: 20px;\n  font-size: 10px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
